<template>
  <context-page :title="$t('subsidy.reviewUsers')" :showLoader="pageLoader">
    <v-card>
        <v-card-actions>
          <v-btn color="#429a86" dark tile @click="Export" :loading="loading">
            <v-icon left>mdi-download</v-icon>
            {{$t('reports.excel')}}</v-btn>
        </v-card-actions>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <VueTabulator id="userManagmentTable" ref="tabulator" v-model="data" :options="tabulatorOptions" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
  </context-page>
</template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/context-page/ContextPage'
import tabulatorMixin from '@/mixins/tabulator'
import FileSaver from 'file-saver'

export default {
  name: 'user-management',
  components: {
    ContextPage
  },
  mixins: [tabulatorMixin],
  data: function () {
    return {
      data: [],
      pageLoader: false,
      loading: false,
      tabulatorOptions: {
        ajaxURL: Vue.$config.api_root_internal + '/' + Vue.$apiConfig.pagedUsersGet,
        columns: [
          { title: 'id', field: 'id', visible: false },
          { title: this.$t('subsidy.userUniqueIdentificationNumber'), align: 'center', field: 'uniqueIdentificationNumber', headerFilter: this.vTextFieldFilter, headerFilterLiveFilter: false },
          { title: this.$t('subsidy.userIdentificationNumber'), align: 'center', field: 'identificationNumber', headerFilter: this.vTextFieldFilter, headerFilterLiveFilter: false },
          { title: this.$t('subsidy.userAccountNumber'), align: 'center', field: 'accountNumber', headerFilter: this.vTextFieldFilter, headerFilterLiveFilter: false },
          { title: this.$t('subsidy.userFirstName'), align: 'center', field: 'firstName', headerFilter: this.vTextFieldFilter, headerFilterLiveFilter: false },
          { title: this.$t('subsidy.userLastName'), align: 'center', field: 'lastName', headerFilter: this.vTextFieldFilter, headerFilterLiveFilter: false },
          {
            title: this.$t('subsidy.paymentDate'),
            align: 'center',
            field: 'paymentDate',
            headerFilter: this.vDateRange,
            headerFilterLiveFilter: false,
            headerFilterParams: { isRange: true },
            formatter: (cell) => { return this.formatDate(cell.getValue()) }
          },
          {
            title: this.$t('subsidy.userStatus'),
            align: 'center',
            field: 'status',
            formatter: (cell, formatterParams, onRendered) => {
              const status = cell.getValue()
              if (status === this.UserStatus.PENDING) {
                return '<span class="status-pending-span">' + this.$t('userStatuses.' + status) + '</span>'
              } else if (status === this.UserStatus.ACTIVE) {
                return '<span class="status-active-span">' + this.$t('userStatuses.' + status) + '</span>'
              } else if (status === this.UserStatus.WAITING_ACCOUNT) {
                return '<span class="status-active-span">' + this.$t('userStatuses.' + status) + '</span>'
              } else if (status === this.UserStatus.PROCESSED) {
                return '<span class="status-active-span">' + this.$t('userStatuses.' + status) + '</span>'
              } else if (status === this.UserStatus.COMPLETED) {
                return '<span class="status-completed-span">' + this.$t('userStatuses.' + status) + '</span>'
              } else if (status === this.UserStatus.REJECTED) {
                return '<span class="status-rejected-span">' + this.$t('userStatuses.' + status) + '</span>'
              }

              return '<span class="status-error-span">' + this.$t('userStatuses.' + status) + '</span>'
            },
            headerFilter: this.vStatusSelect,
            headerFilterParams: {
              items: [
                { text: this.$t('userStatuses.1'), value: 1 },
                { text: this.$t('userStatuses.2'), value: 2 },
                { text: this.$t('userStatuses.3'), value: 3 },
                { text: this.$t('userStatuses.4'), value: 4 },
                { text: this.$t('userStatuses.5'), value: 5 },
                { text: this.$t('userStatuses.6'), value: 6 },
                { text: this.$t('userStatuses.7'), value: 7 },
                { text: this.$t('userStatuses.8'), value: 8 },
                { text: this.$t('userStatuses.101'), value: 101 },
                { text: this.$t('userStatuses.102'), value: 102 }
              ]
            },
            headerFilterLiveFilter: false
          }
        ],
        rowClick: (e, row) => {
          this.$router.push({ name: 'userDetails', params: { userId: row.getData().uniqueIdentificationNumber } })
        }
      }
    }
  },
  methods: {
    generateFilterQuery (reportType) {
      const queryParams = []
      queryParams.push(...this.getReportFilter())
      return queryParams.join('&')
    },
    Export () {
      this.loading = true
      const query = this.generateFilterQuery()
      this.$http.get(Vue.$apiConfig.userReportGet + '?' + query, { responseType: 'blob' })
        .then(response => {
          this.loading = false
          var headers = response.headers
          var blob = new Blob([response.data], { type: headers['content-type'] })
          FileSaver.saveAs(blob, `Пријављени корисници - ${this.formatDate(new Date())}.xlsx`)
        },
        error => {
          this.loading = false
          this.logConsole(error)
          this.formatErrorResponse(error)
        })
    }
  }
}
</script>
